module.exports = __webpack_public_path__ + "static/img/GLENN_MAXWELL.e83577d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GLENN_MAXWELL.jpg
// module id = 870d
// module chunks = 0